import React from 'react';

const ServiceCouponDetail = ({ viewPackageCarModal }) => {
  return (
    <div className={`${viewPackageCarModal ? 'fixed mr-4' : ''}`}>
      <p className="text-sm font-bold text-reliableBlack mb-2 uppercase lg:text-base">
        DETAIL KUPON SERVIS
      </p>
      <p>Paket pemeriksaan kondisi kendaraan lebih dari 20 titik pemeriksaan terdiri dari :</p>
      <ul className="text-xs font-normal leading-relaxed list-disc text-reliableBlack90 mb-2 lg:text-sm lg:text-reliableBlack">
        <li className="list-item ml-4 mb-1">
          <span className="font-semibold">Komponen mesin :</span> Pengecekan Oli Mesin/Filter, Air
          Pendingin, Aki, Filter Udara, Tali Kipas
        </li>
        <li className="list-item ml-4 mb-1">
          <span className="font-semibold">Komponen elektrik :</span> Pengecekan Lampu Besar,Kecil,
          Sein, Hazard, Mundur, Panel...
        </li>
      </ul>

      <button className="inline-block text-xs font-medium text-hyperLink uppercase">
        Lihat Selengkapnya
      </button>
    </div>
  );
};

export default ServiceCouponDetail;
